import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center text-lg">
                <i className="ri-flight-takeoff-line text-primary-400"></i>
              </span>
              <span className="font-heading text-xl font-bold text-white">亚洲天堂</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汇聚亚洲最令人心动的旅游目的地与度假胜地，带你领略东方最极致的自然风光与人文魅力。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              旅行分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              热门目的地
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/bali-daoyu-dujia-zhinan" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">巴厘岛</Link></li>
              <li><Link to="/article/jingdu-gulao-sheyuan-zhinan" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">京都</Link></li>
              <li><Link to="/article/maerdaifu-shechi-dujia" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">马尔代夫</Link></li>
              <li><Link to="/article/dongjing-shechi-lvxing-zhinan" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">东京</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">品牌故事</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 亚洲天堂. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="WeChat">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line"></i></span>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="Weibo">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line"></i></span>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="Instagram">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-instagram-line"></i></span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}